var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSx = function SvgSx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.773 0c.392 0 .784.262.915.654s.131.784-.13 1.046L6.55 4.315v5.1c0 .523-.392 1.046-.915 1.046-.262 0-.393-.13-.523-.13l-1.308-.785c-.262-.262-.523-.523-.523-.916V4.446c0-.13 0-.13-.13-.13L.272 1.7C.012 1.438-.119.915.143.654.273.262.535 0 .927 0h7.846Zm.784 7.584c.262 0 .393.131.393.393 0 .261-.131.392-.393.392H7.334c-.261 0-.392-.131-.392-.392 0-.262.131-.393.392-.393h2.223Zm0-1.438c.262 0 .393.13.393.392s-.131.392-.393.392H7.334c-.261 0-.392-.261-.392-.392 0-.261.131-.392.392-.392h2.223Zm0-1.57c.262 0 .393.131.393.393 0 .261-.131.392-.393.392H7.334c-.261 0-.392-.261-.392-.392 0-.262.131-.392.392-.392h2.223Z",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  })));
};

export default SvgSx;